<template>
  <!-- <div class="container event-management-container"> -->
  <div
    class="container event-management-container"
    :class="event.current_locale === 'en' ? 'en-class' : 'he-class'"
  >
    <section class="event-management-wrap">
      <event-item
        :event-item="eventItem"
        v-for="eventItem in events"
        :highlight="eventItem.id == event.highlight && !draft ? true : false"
        :key="eventItem.id"
      ></event-item>

      <event-item
        v-for="(draftItem, idx) in drafts"
        :event-item="draftItem"
        :key="idx"
        :highlight="draft && event.highlight == draftItem.id ? true : false"
        :draft="true"
      ></event-item>

      <a
        :href="event.create.replace('%id%', '')"
        class="event-item event-create-item"
      >
        <div class="event-item-inner">
          <span class="create-event-plus"></span>
          <span class="create-event">{{ $trans("event.manage.create") }}</span>
        </div>
      </a>
    </section>
  </div>
</template>

<script>
import EventItem from "./EventItem";

import { nextTick } from "vue";

export default {
  props: ["scroll"],
  components: {
    EventItem,
  },
  data() {
    return {
      event: window.app.event,
      // draftEvent: window.app.event.draft_event,
      drafts: window.app.event.drafts,
      draft: window.app.event.draft,
      events: window.app.events,
    };
  },
  mounted() {
    // console.log("draftttttt", this.draft);
    // console.log("saveeeeee", this.events);
    if (this.scroll && this.scroll.length) {
      nextTick(() => {
        $("body, html").animate(
          {
            scrollTop: $(`.event-item-${this.scroll}`).offset().top,
          },
          "slow"
        );
      });
    }
  },
};
</script>
